import store from '../store'
import find from 'lodash/find'
 
export function getRepoforId(repoId) {	
	if(repoId){
		const state = store.getState()
		const repo= find(state.repos, {'id':repoId})
		
		if(repo){
			return repo
		}else return null
	}else return null

}




// WEBPACK FOOTER //
// ./src/utils/getRepoforId.js